export const CHANGE_INFORMATION = "CHANGE_INFORMATION";
export const SAVE_INFORMATION = "SAVE_INFORMATION";
export const SAVE_DRAFT = "SAVE_DRAFT";
export const SET_CREATE_STEP = "SET_CREATE_STEP";
export const CLEAR_INFORMATION = "CLEAR_INFORMATION";
export const VALIDATE_INFORMATION = "VALIDATE_INFORMATION";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_VOCABULARIES = "SET_VOCABULARIES";
export const SET_CUR_LANG = "SET_CUR_LANG";
export const SET_SEARCH_FIELDS = "SET_SEARCH_FIELDS";